import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

interface MyParams extends ICellRendererParams {
    Enum: any;
}

@Component({
    selector: 'enum-renderer',
    template: `{{params.Enum[this.params.value] ? params.Enum[this.params.value].replace('_', ' ') : ''}}`,
})
export class EnumRendererComponent implements ICellRendererAngularComp {
    public params: MyParams;

    agInit(params: any): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/grid/renderer/enum-renderer.component.ts